export const getStory="storydata"
export const commondata="getallcommondata"
export const loginsuccess="loginsuccessfull"
export const bookdata="getbookdata"
export const logout="logout"